import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const GuidedOverbreathingForm = ({selectedFormId,data,selectedClientDetails}) => {
  const { t } = useTranslation();
  const initialFormData =   {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    typeC: false,
    typeA: false,
    typeT: false,
    sessionNumber: "",
    date: "",
    practitionerName: "",
    email: "",
    depth: "",
    rate: "",
    modeling: "",
    levels: "",
    focus: "",
    head: "",
    jaws: "",
    throat: "",
    upperBody: "",
    chest: "",
    heart: "",
    abdomen: "",
    feelLegs: "",
    fingersLips: "",
    vision: "",
    sound: "",
    muscles: "",
    pain: "",
    consciousness: "",
    attention: "",
    thoughts: "",
    memories: "",
    negativeEmotions: "",
    positiveEmotions: "",
    senseOfSelf: "",
    senseOfControl: "",
    other: "",
    clientRecovered: "",
    recoveryTime: "",
    clientExplanation: "",
    assistanceProvided: "",
    outcomeDescription: "",
    selfInterventions: [],
    otherIntervention: "",
    mostUsefulInterventions: "",
    notUsefulInterventions: "",
    recoveryInterview: "",
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFormData({
        ...formData,
        selfInterventions: [...formData.selfInterventions, value],
      });
    } else {
      setFormData({
        ...formData,
        selfInterventions: formData.selfInterventions.filter(
          (item) => item !== value
        ),
      });
    }
  };

  const interventionOptions = [
    "Observe your breath; watch it, but don't manipulate it.",
    "Exhale completely, but not forcibly.",
    "Extend the transition times from exhale to inhale.",
    "Breathe with your diaphragm, if possible.",
    "Breathe slowly, but NOT deeply.",
    "Breathe through your nose.",
    "Breathe gently and as quietly as possible.",
    "Stop negative thoughts about your breathing.",
    "Think embracing thoughts about people, circumstances, and events.",
    "Translate anxiety into excitement",
    "Use earplugs, and listen to your breathing. Make it as quiet as possible.",
    "Extend the transition to longer and longer times: 2, 4, 8 seconds.",
    "Take smaller breaths, and don't worry about how fast or slow.",
    "Hold your breath, letting CO2 accumulate.",
    "Use a paper bag if necessary, and repeat the above.",
    "Other",
  ];

    const symptomsList = [
    {
      key: "head",
      label: "Head?",
      question: "Do you feel dizzy, sleepy, headache, or ringing in your ears?",
    },
    {
      key: "jaws",
      label: "Jaws?",
      question: "Are they tight, painful, difficult to move, or relaxed?",
    },
    {
      key: "throat",
      label: "Throat?",
      question:
        "Can you swallow, breathe, and talk normally? Is your throat closing?",
    },
    {
      key: "upperBody",
      label: "Upper body?",
      question:
        "Do you feel cold or hot, constrained, limited, restricted, uncomfortable?",
    },
    {
      key: "chest",
      label: "Chest?",
      question: "Do you feel tightness, constriction, pressure, or pain?",
    },
    {
      key: "heart",
      label: "Heart?",
      question: 'Is your heart racing? Does it feel "funny"? Does it worry you?',
    },
    {
      key: "abdomen",
      label: "Abdomen?",
      question: "Do you feel nauseous? Are you cramping? Do you feel pain?",
    },
    {
      key: "feelLegs",
      label: "Feet, legs?",
      question: "Can you feel your feet? Do they feel connected to you?",
    },
    {
      key: "fingersLips",
      label: "Fingers, lips?",
      question: "Are they numb, tingling, cold, warm, stiff, dry, or wet?",
    },
    {
      key: "vision",
      label: "Vision?",
      question: "Look around. Can you focus? Can you see clearly?",
    },
    {
      key: "sound",
      label: "Sound?",
      question: "Does my voice seem further away, closer, or the same?",
    },
    {
      key: "muscles",
      label: "Muscles?",
      question: "Do you feel muscle cramping, stiffness, or pain?",
    },
    {
      key: "pain",
      label: "Pain?",
      question:
        "Is pain appearing in places you've been previously challenged?",
    },
    {
      key: "consciousness",
      label: "Consciousness?",
      question:
        "Do you feel disconnected, disoriented, unfocused, or confused?",
    },
    {
      key: "attention",
      label: "Attention?",
      question: "Can you focus? Are you alert, clear headed, or scattered?",
    },
    {
      key: "thoughts",
      label: "Thoughts?",
      question:
        "What are you saying to yourself? What images are coming to you?",
    },
    {
      key: "memories",
      label: "Memories?",
      question:
        "Does this experience remind you of past or present events?",
    },
    {
      key: "negativeEmotions",
      label: "Negative emotions?",
      question:
        "Do you feel anxious, angry, upset, threatened, isolated, or fearful?",
    },
    {
      key: "positiveEmotions",
      label: "Positive emotions?",
      question:
        "Do you feel safer, relieved, drugged, freed, good, or better?",
    },
    {
      key: "self",
      label: "Sense of self?",
      question:
        "Do you feel more or less confident, more or less vulnerable?",
    },
    {
      key: "control",
      label: "Sense of control?",
      question:
        "Do you feel more or less in control? If so, how does it matter?",
    },
    {
      key: "otherSymptoms",
      label: "Other (e.g., body temperature)?",
      question: "",
    },
  ];

  const inputStyle = {
    borderBottom: "1px solid black",
    marginTop: "5px",
    marginLeft: "15px",
    backgroundColor: "#f1f4ff",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    height: "30px",
    width: "40%",
    flex:1
  };

  const renderRow = ({ key, label, question }) => (
    <div
      key={key}
      style={{ display: "flex", alignItems: "flex-end", marginTop: "10px" }}
    >
      <p>
        <input
          type="checkbox"
          id={key}
          name={key}
          checked={!!formData[key]}
          onChange={handleInputChange}
        />
        <span style={{ fontWeight: "bold" }}> {label} </span>
        {question}
      </p>
      <input
        type="text"
        name={`${key}Comment`}
        value={formData[`${key}Comment`] || ""}
        onChange={handleInputChange}
        style={inputStyle}
      />
    </div>
  );
  

    const renderQuestion = (key, label, questionText, noteText) => (
    <div style={{ marginTop: "15px" }} key={key}>
      <p>
        <input
          type="checkbox"
          id={key}
          name={key}
          checked={formData[key] || false}
          onChange={handleInputChange}
        />
        <span style={{ fontWeight: "bold" }}>{label}</span> {questionText}
      </p>

      <input
        type="text"
        name={`${key}Text`}
        value={formData[`${key}Text`] || ""}
        onChange={handleInputChange}
        style={{
          borderBottom: "1px solid black",
          marginTop: "5px",
          marginBottom: "5px",
          marginLeft: "15px",
          width: "95%",
          backgroundColor: "#f1f4ff",
          borderTop: "none",
          borderLeft: "none",
          borderRight: "none",
          height: "30px",
        }}
      />

      <p
        style={{
          fontSize: "14px",
          fontStyle: "italic",
          marginLeft: "15px",
        }}
      >
        Note: {noteText}
      </p>
    </div>
  );

  // ✅ Question list to avoid repetition
  const coachingQuestions = [
    {
      key: "depth",
      label: "DEPTH:",
      questionText: "Describe the details of what you did and its outcomes.",
      noteText: "Increase the size of the breath gradually and incrementally.",
    },
    {
      key: "rate",
      label: "RATE:",
      questionText: "Describe the details of what you did and its outcomes.",
      noteText:
        "Increase breathing rate sparingly. Aborted exhales may result in inaccurate readings.",
    },
    {
      key: "modeling",
      label: "MODELING:",
      questionText: "Describe the details of what you did and its outcomes.",
      noteText:
        "If coaching is ineffective, modeling overbreathing may become necessary.",
    },
    {
      key: "levels",
      label: "LEVELS:",
      questionText:
        "To what levels of PetCO₂ did you coach your client, how long, and why?",
      noteText:
        "Customize levels of PetCO₂ based on client uniqueness (e.g., mild levels may suffice).",
    },
    {
      key: "focus",
      label: "FOCUS:",
      questionText:
        "What was your coaching focus while bringing down PetCO₂ levels and why?",
      noteText:
        "Focus on physical and psychological changes based on earlier information gathering.",
    },
  ];

const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  // console.log(formData);
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id:  localStorage.getItem("selectedSession") || null,
  };


  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};
  return (
    <div
      style={{
             maxWidth: "1200px",
      margin: "0 auto",
      padding: !data?16:10,
      border: !data && "1px solid #ccc",
      backgroundColor: "white",
      fontFamily: "Arial, sans-serif",
      marginTop: 16,
      }}
    >
      <h1
        style={{
        fontSize: "22px",
        fontWeight: "bold",
        color: "#800080",
        textAlign: "center",
        marginBottom: "16px",
        }}
      >
        GUIDED OVERBREATHING
      </h1>

     <div className="client-info">
  <div className="client-info-item">
    <label>Client Name:</label>
    <input
      type="text"
      name="clientName"
      disabled={Boolean(selectedClientDetails)}
      value={formData.clientName}
      onChange={handleInputChange}
      style={{
        border: "none",
        borderBottom: "1px solid black",
        backgroundColor: "#f1f4ff",
        height: "30px",
      }}
    />
  </div>

  <div className="client-info-item">
    <label style={{ marginRight: "10px" }}>Type:</label>
    <div className="type-checkboxes">
      <input
        type="checkbox"
        id="typeA"
        name="typeA"
        checked={formData.typeA}
        onChange={handleInputChange}
      />
      <label htmlFor="typeA" className="checkbox-label-small">
        A
      </label>

      <input
        type="checkbox"
        id="typeT"
        name="typeT"
        checked={formData.typeT}
        onChange={handleInputChange}
      />
      <label htmlFor="typeT" className="checkbox-label-small">
        T
      </label>

      <input
        type="checkbox"
        id="typeC"
        name="typeC"
        checked={formData.typeC}
        onChange={handleInputChange}
      />
      <label htmlFor="typeC" className="checkbox-label-small">
        C
      </label>
    </div>
  </div>

  <div className="client-info-item">
    <label>Session #</label>
    <input
      type="text"
      name="sessionNumber"
      value={formData.sessionNumber}
      onChange={handleInputChange}
      style={{
        width: "50px",
        border: "none",
        borderBottom: "1px solid black",
        backgroundColor: "#f1f4ff",
        height: "30px",
      }}
    />
  </div>

  <div className="client-info-item">
    <label>Date:</label>
    <input
      type="text"
      name="date"
      value={formData.date}
      onChange={handleInputChange}
      style={{
        width: "100px",
        border: "none",
        borderBottom: "1px solid black",
        backgroundColor: "#f1f4ff",
        height: "30px",
      }}
    />
  </div>
</div>

<div
  className="form-row"
  style={{
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    margin: "10px 0px",
  }}
>
  <label>Practitioner Name:</label>
  <input
    type="text"
    name="practitionerName"
    value={formData.practitionerName}
    onChange={handleInputChange}
    style={{
      flex: 1,
      border: "none",
      borderBottom: "1px solid black",
      backgroundColor: "#f1f4ff",
      height: "30px",
    }}
  />

  <label>Email:</label>
  <input
    type="email"
    name="email"
    value={formData.email}
    onChange={handleInputChange}
    style={{
      flex: 1,
      height: "30px",
      border: "none",
      borderBottom: "1px solid black",
      backgroundColor: "#f1f4ff",
    }}
  />
</div>


      <div style={{ marginBottom: "15px" }}>
        <p style={{ fontWeight: "bold" }}>
          Intentional overbreathing{" "}
          <span style={{ fontWeight: "normal" }}>
            is an important discovery and learning tool for people who already
            overbreathe. Learning what hypocapnia 'feels like' is a very
            important part of evaluation and training.
          </span>{" "}
          <span style={{ fontWeight: "bold" }}>
            Does your client automatically recover without your assistance?
          </span>{" "}
          <span style={{ fontWeight: "normal" }}>
            Failure to recover from hypocapnia is often a key consideration in
            vicious circle dysfunctional breathing.
          </span>
        </p>
        <p style={{ marginTop: "10px" }}>
          While guiding your clients into hypocapnia look for triggered physical
          symptoms, emotions, thoughts, memories, and shifts in consciousness.{" "}
          <span style={{ fontWeight: "bold" }}>
            Does changing PCO₂ remind your client of earlier times, places, or
            people?
          </span>
        </p>
        <p style={{ marginTop: "10px" }}>
          Ask your client about their experiences (phenomenology), to be
          answered privately to themselves, while overbreathing. Interview your
          clients about these experiences during the recovery period (not during
          the guided overbreathing itself), although do NOT assist the client in
          the recovery process, unless (s)he fails to show signs of recovery
          after five minutes or more.
        </p>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <p style={{ fontWeight: "bold" }}>
          Which of the following were important while coaching your client to
          overbreathe? How and why?
        </p>

      {coachingQuestions.map((q) =>
        renderQuestion(q.key, q.label, q.questionText, q.noteText)
      )}
    
        {symptomsList.map(renderRow)}
      </div>

      <div>
        <h3
          style={{
            color: "#0078d7",
            margin: "10px 0",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          PRECAUTIONS
        </h3>
        <p style={{ margin: "10px 0", fontSize: "14px", lineHeight: "1.4" }}>
          By taking proper precautions, neither the practitioner nor the
          learner, need be afraid of intentional overbreathing. After all,
          overbreathing is the problem, and as a behavior, it must be addressed.
          In fact, fear of overbreathing and its effects may even contribute to
          the problem. These precautions include:
        </p>
        <div
          style={{
            margin: 0,
          }}
        >
          <li style={{ fontSize: "14px", marginBottom: "5px" }}>
            <span
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "#0070c0",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>{" "}
            having a paper bag available,
          </li>
          <li style={{ fontSize: "14px", marginBottom: "5px" }}>
            <span
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "#0070c0",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>{" "}
            being vigilant of indicative behavioral nuances,
          </li>
          <li style={{ fontSize: "14px", marginBottom: "5px" }}>
            <span
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "#0070c0",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>{" "}
            advising the client that s(he) may discontinue at any time,
          </li>
          <li style={{ fontSize: "14px", marginBottom: "5px" }}>
            <span
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "#0070c0",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>{" "}
            being prepared to stop coaching when you see a contraindication, and
          </li>
          <li style={{ fontSize: "14px", marginBottom: "5px" }}>
            <span
              style={{
                height: "10px",
                width: "10px",
                backgroundColor: "#0070c0",
                borderRadius: "50%",
                display: "inline-block",
              }}
            ></span>{" "}
            being prepared to implement short-term interventions.
          </li>
        </div>
      </div>

      {/* RECOVERY SECTION */}
      <div>
        <h3
          style={{
            color: "#0078d7",
            margin: "20px 0 10px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          RECOVERY
        </h3>

        <div style={{ margin: "10px 0", fontSize: "14px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <label>
              Did your client recover from hypocapnia, without your assistance?
            </label>
            <div style={{ marginLeft: "10px" }}>
              <input
                type="radio"
                name="clientRecovered"
                value="YES"
                checked={formData.clientRecovered === "YES"}
                onChange={handleInputChange}
                style={{ marginRight: "5px" }}
              />
              <label style={{ marginRight: "10px" }}>YES</label>

              <input
                type="radio"
                name="clientRecovered"
                value="NO"
                checked={formData.clientRecovered === "NO"}
                onChange={handleInputChange}
                style={{ marginRight: "5px" }}
              />
              <label>NO</label>
            </div>
          </div>

          <div style={{ margin: "5px 0" }}>
            <label>If so, how long did it take?</label>
            <input
              type="text"
              name="recoveryTime"
              value={formData.recoveryTime}
              onChange={handleInputChange}
              style={{
                marginLeft: "10px",
                width: "300px",
                borderBottom: "1px solid #000",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                height: "30px",
                backgroundColor: "#f1f4ff",
              }}
            />
          </div>

          <div style={{ margin: "5px 0" }}>
            <label>If not, what was your client's explanation?</label>
            <input
              type="text"
              name="clientExplanation"
              value={formData.clientExplanation}
              onChange={handleInputChange}
              style={{
                width: "100%",
                marginTop: "5px",
                borderBottom: "1px solid #000",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                height: "30px",
                backgroundColor: "#f1f4ff",
              }}
            />
          </div>
        </div>

        <div style={{ margin: "10px 0", fontSize: "14px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <label>
              If you gave assistance, did your client return to normal?
            </label>
            <div style={{ marginLeft: "10px" }}>
              <input
                type="radio"
                name="assistanceProvided"
                value="YES"
                checked={formData.assistanceProvided === "YES"}
                onChange={handleInputChange}
                style={{ marginRight: "5px" }}
              />
              <label style={{ marginRight: "10px" }}>YES</label>

              <input
                type="radio"
                name="assistanceProvided"
                value="NO"
                checked={formData.assistanceProvided === "NO"}
                onChange={handleInputChange}
                style={{ marginRight: "5px" }}
              />
              <label>NO</label>
            </div>
          </div>

          <div style={{ margin: "5px 0" }}>
            <label>If not, describe the outcome:</label>
            <input
              type="text"
              name="outcomeDescription"
              value={formData.outcomeDescription}
              onChange={handleInputChange}
              style={{
                width: "100%",
                marginTop: "5px",
                borderBottom: "1px solid #000",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                height: "30px",
                backgroundColor: "#f1f4ff",
              }}
            />
          </div>
        </div>

        {/* Self Interventions Checkboxes */}
        <div style={{ margin: "15px 0", fontSize: "14px" }}>
          <p style={{ marginBottom: "10px" }}>
            Which of the following self-interventions did you implement?
          </p>

          {interventionOptions.map((option, index) => (
            <div
              key={index}
              style={{
                margin: "5px 0",
                display: "flex",
                alignItems: "flex-start",
              }}
            >
              <input
                type="checkbox"
                id={`intervention-${index}`}
                value={option}
                checked={formData.selfInterventions.includes(option)}
                onChange={handleCheckboxChange}
                style={{ marginRight: "8px", marginTop: "3px" }}
              />
              <label htmlFor={`intervention-${index}`}>{option}</label>
              {option === "Other" && (
                <input
                  type="text"
                  name="otherIntervention"
                  value={formData.otherIntervention}
                  onChange={handleInputChange}
                  style={{
                    flex: 1,
                    marginLeft: "5px",
                    borderBottom: "1px solid #000",
                    borderTop: "none",
                    borderLeft: "none",
                    borderRight: "none",
                    height: "30px",
                    backgroundColor: "#f1f4ff",
                  }}
                />
              )}
            </div>
          ))}
        </div>

        {/* Most Useful/Not Useful Interventions */}
        <div style={{ margin: "15px 0", fontSize: "14px" }}>
          <div style={{ margin: "10px 0" }}>
            <label>
              Which self-interventions, if used, were the most useful?
            </label>
            <input
              type="text"
              name="mostUsefulInterventions"
              value={formData.mostUsefulInterventions}
              onChange={handleInputChange}
              style={{
                width: "100%",
                marginTop: "5px",
                borderBottom: "1px solid #000",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                height: "30px",
                backgroundColor: "#f1f4ff",
              }}
            />
          </div>

          <div style={{ margin: "10px 0" }}>
            <label>
              Which self-interventions, if any, were not useful? What is your
              explanation?
            </label>
            <input
              type="text"
              name="notUsefulInterventions"
              value={formData.notUsefulInterventions}
              onChange={handleInputChange}
              style={{
                width: "100%",
                marginTop: "5px",
                borderBottom: "1px solid #000",
                borderTop: "none",
                borderLeft: "none",
                borderRight: "none",
                height: "30px",
                backgroundColor: "#f1f4ff",
              }}
            />
          </div>
        </div>
      </div>

      {/* RECOVERY INTERVIEW SECTION */}
      <div>
        <h3
          style={{
            color: "#0078d7",
            margin: "20px 0 10px",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          RECOVERY INTERVIEW{" "}
          <span style={{ fontWeight: "normal", color: "#000" }}>
            (time frame following guided overbreathing):
          </span>
        </h3>

        <p style={{ margin: "10px 0", fontSize: "14px" }}>
          What did your client say about their overbreathing experience? Did it
          remind your client of earlier times, places, or people? What did (s)he
          say about the experience of recovery? What did your client learn?
        </p>

        <textarea
          name="recoveryInterview"
          value={formData.recoveryInterview}
          onChange={handleInputChange}
          style={{
            width: "100%",
            height: "120px",
            border: "1px solid #000",
            marginTop: "5px",
            resize: "none",
            backgroundColor: "#f1f4ff",
          }}
        />
      </div>
      {!data &&   <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>
        {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
        <Modal
                                                  isOpen={successModal}
                                                  toggle={successToggleModal}
                                                  className="connect-box"
                                                  centered={true}
                                                >
                                                  <ModalHeader toggle={successToggleModal}>
                                                    <span className="ml-1 roititle font-weight-bold">
                                                      Successfull
                                                    </span>
                                                  </ModalHeader>
                                                  <ModalBody>
                                                    <div className="modal-p">
                                                      <p>Trainer form has been submitted successfully.</p>
                                                    </div>
                                                  </ModalBody>
                                                </Modal>
    </div>
  );
};

export default GuidedOverbreathingForm;
